module.exports = __webpack_public_path__ + "img/stoperDodIcon.0d08f86e.svg";